import React, { ReactNode } from 'react';

interface CustomModalProps {
  isOpen: boolean;
  onClose?: () => void;
  children: ReactNode;
  clickAway?: boolean;
  className?: string;
  zIndex?: number;
}

const CustomModal = ({
  isOpen,
  onClose,
  children,
  clickAway = true,
  className, //기본 alert창 zIndex 최상위값
}: CustomModalProps) => {

  if (!isOpen) return null;
  return (
    <div
      className={`modal-overlay ${className}`}
      onClick={clickAway && onClose ? () => onClose() : undefined}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()} // 모달 바깥쪽을 클릭했을 때만 모달을 닫도록 이벤트 전파 중지
      >
        {children}
      </div>
    </div>
  );
};

export default CustomModal;
